/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCcAmex = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 4v5h-3.128l-.732.914L17.458 9h-6.73l-.577 1.547L9.559 9H6.863v.704L6.563 9H4.257L2 14.992V4z" />
        <path d="M22 15v5H2v-5.008h2.702l.335-.955h.766l.335.955h2.974v-.729l.265.73h1.539l.265-.745v.744h6.185l.753-.93.704.93zm0 0V9l-2.265 3.013z" />
        <path
          d="M12.695 9.851H11.26l-1.066 2.913-1.156-2.913H7.594v4.063L6.097 9.851H4.78l-1.583 4.3h.963l.34-.964h1.84l.341.964h1.797v-3.37l1.281 3.37h.782l1.273-3.37.007 3.37h.874zm-6.669 2.445H4.814l.606-1.717zM20.34 9.851h-1.086l-1.121 1.408-1.087-1.408h-3.552v4.297h3.497l1.127-1.424 1.087 1.424h1.136l-1.651-2.136zm-5.969.89h2.217l.967 1.255-1.01 1.262H14.37v-.857h1.938v-.875H14.37z"
          clipRule="evenodd"
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgCcAmex as CcAmex };
